import * as classNames from 'classnames';
import * as React from 'react';

import * as styles from './Header.css';

interface IHeaderProps {
  noResize?: boolean;
  content: React.ReactNode;
}

export const Header: React.FC<IHeaderProps> = ({ content, noResize, children }) => {
  return (
    <div className={classNames(styles['wrapper'], noResize && styles['static'])}>
      <div className={styles['inner']}>{content}</div>
      {children}
    </div>
  );
};
